import type { Signal } from '@angular/core';
import { computed } from '@angular/core';
import type { InnogyComponentRendering } from '@core/jss-models';

import type { ContentSectionTheme } from './content-section.model';

export const computedContentSectionTheme = (
  rendering: Signal<InnogyComponentRendering | undefined>
) => computed(() => rendering()?.params?.['theme'] as ContentSectionTheme);
